import { DefineComponentProps } from 'utils'

interface MenuIconProps {
  fill?: string
}

export const MenuIcon = defineComponent<MenuIconProps>({
  props: DefineComponentProps<MenuIconProps>(['fill']),
  setup(props) {
    return () => (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_129978_87103" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
          <path
            d="M23.6622 8.8908H4.92571C4.61976 8.8908 4.375 8.64604 4.375 8.34009V6.67571C4.375 6.36976 4.61976 6.125 4.92571 6.125H23.6622C23.9681 6.125 24.2129 6.36976 24.2129 6.67571V8.34009C24.2129 8.64604 23.9681 8.8908 23.6622 8.8908ZM19.2872 21.3124H4.92571C4.61976 21.3124 4.375 21.0677 4.375 20.7617V19.0973C4.375 18.7914 4.61976 18.5466 4.92571 18.5466H19.2872C19.5931 18.5466 19.8379 18.7914 19.8379 19.0973V20.7617C19.8379 21.0677 19.5931 21.3124 19.2872 21.3124ZM23.6622 15.1444H4.92571C4.61976 15.1444 4.375 14.8997 4.375 14.5937V12.9294C4.375 12.6234 4.61976 12.3786 4.92571 12.3786H23.6622C23.9681 12.3786 24.2129 12.6234 24.2129 12.9294V14.5937C24.2129 14.8997 23.9681 15.1444 23.6622 15.1444Z"
            fill={props.fill || 'var(--colors-bg-icon-primary)'}
          />
        </mask>
        <g mask="url(#mask0_129978_87103)">
          <rect width="28" height="28" fill={props.fill || 'var(--colors-bg-icon-primary)'} />
        </g>
      </svg>
    )
  },
})
